function throttle (func, delay) {
    var timer = null;

    return function () {
        var context = this, args = arguments;

        if (timer == null) {
            timer = setTimeout(function () {
                func.apply(context, args);
                timer = null;
            }, delay);
        }
    };
}

export default throttle;


// WEBPACK FOOTER //
// ./src/js/app/util/throttle.js